import script from "./CreatePost.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePost.vue?vue&type=script&setup=true&lang=js"

import "./CreatePost.vue?vue&type=style&index=0&id=4a807b6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a807b6a"]])

export default __exports__